import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import '../../styling/dialog.css'
import { useState } from "react"
import { strings } from "../../strings"
import { useBookingsContext } from "../../hooks/useBookingsContext"
import { useAuthContext } from "../../hooks/useAuthContext"

const CustomActions = ({ machineID, eventID, closeCancel, taken }) => {

    const { bookings, bookedLaundrySlots, dispatch } = useBookingsContext()
    const { user } = useAuthContext()
    const [error, setError] = useState(null)

    const deleteEvent = async () => {

        if (!user) {
            return
        }
        setError(null)

        const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/bookings/' + eventID, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${user.token}`
            }
        })

        const json = await response.json()

        if (!response.ok) {
            setError(json.msg)
        }

        if (response.ok) {
            setError(null)
            dispatch({ type: 'DELETE_BOOKING', payload: json })
            dispatch({
                type: 'SET_BOOKED_LAUNDRY_SLOTS', payload: bookedLaundrySlots.filter(b => {
                    return b._id !== eventID
                })
            })
        }

        closeCancel()
    }

    const updateEvent = async (choice) => {
        if (!user) {
            return
        }
        setError(null)

        const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/bookings/' + eventID, {
            method: 'PATCH',
            body: JSON.stringify({ machineID: choice }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.token}`
            }
        })

        const json = await response.json()

        if (!response.ok) {
            setError(json.msg)
        }

        if (response.ok) {
            setError(null)
            const myUpdatedBookings = bookings.map((b) => {
                if (b._id === eventID) {
                    return { ...b, machineID: choice }
                }
                return b
            })

            const updatedLaundryBookings = bookedLaundrySlots.map((b) => {
                if (b._id === eventID) {
                    return { ...b, machineID: choice }
                }
                return b
            })

            dispatch({ type: 'SET_BOOKINGS', payload: myUpdatedBookings })
            dispatch({ type: 'SET_BOOKED_LAUNDRY_SLOTS', payload: updatedLaundryBookings })
        }

        closeCancel()
    }

    if (machineID === 1) {
        return (
            <DialogActions className="dialog-actions">
                <span className="confirm-dialog" onClick={deleteEvent} style={{ cursor: "pointer" }}>
                    {strings.dialogs.cancelPillar + "1"}
                </span>

                {!taken && <span className="confirm-dialog" onClick={() => updateEvent(3)} style={{ cursor: "pointer" }}>
                    {strings.dialogs.bookPillar + "2"} {/*New MachineID: 3*/}
                </span>}

                <span className="cancel-dialog" onClick={closeCancel} style={{ cursor: "pointer" }}>
                    {strings.dialogs.cancel}
                </span>

                {error && <div className="error">{error}</div>}

            </DialogActions>
        )
    }


    if (machineID === 2) {
        return (
            <DialogActions className="dialog-actions">
                {!taken && <span className="confirm-dialog" onClick={() => updateEvent(3)} style={{ cursor: "pointer" }}>
                    {strings.dialogs.bookPillar + "1"} {/*New MachineID: 3*/}
                </span>}

                <span className="confirm-dialog" onClick={deleteEvent} style={{ cursor: "pointer" }}>
                    {strings.dialogs.cancelPillar + "2"}
                </span>

                <span className="cancel-dialog" onClick={closeCancel} style={{ cursor: "pointer" }}>
                    {strings.dialogs.cancel}
                </span>

                {error && <div className="error">{error}</div>}

            </DialogActions>
        )
    }


    if (machineID === 3) {
        return (
            <DialogActions className="dialog-actions">
                <span className="confirm-dialog" onClick={() => updateEvent(2)} style={{ cursor: "pointer" }}>
                    {strings.dialogs.cancelPillar + "1"} {/*New MachineID: 2*/}
                </span>
                <span className="confirm-dialog" onClick={() => updateEvent(1)} style={{ cursor: "pointer" }}>
                    {strings.dialogs.cancelPillar + "2"} {/*New MachineID: 1*/}
                </span>
                <span className="confirm-dialog" onClick={deleteEvent} style={{ cursor: "pointer" }}>
                    {strings.dialogs.cancelPillar + "1 & 2"}
                </span>

                <span className="cancel-dialog" onClick={closeCancel} style={{ cursor: "pointer" }}>
                    {strings.dialogs.cancel}
                </span>

                {error && <div className="error">{error}</div>}

            </DialogActions>
        )
    }

}

const EditEventDialog = ({ open, closeCancel, event }) => {

    let w = window.innerWidth
    let h = window.innerHeight

    return (
        <Dialog className="confirmation-dialog" open={open}>
            <DialogTitle style={{ width: `${w > h ? '30vw' : '65vw'}` }}>{strings.dialogs.updateTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {strings.dialogs.updateAction}
                </DialogContentText>

            </DialogContent>
            {event && <CustomActions machineID={event.machineID} eventID={event._id} closeCancel={closeCancel} taken={event.takenBySomeoneElse} />}
        </Dialog>
    )

}

export default EditEventDialog